<div class="edit-media-dialog">
  <h2 mat-dialog-title>Edit Media</h2>
  
  <mat-dialog-content>
    <form [formGroup]="editForm" class="edit-form">
      <!-- Title -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" placeholder="Enter title">
        <mat-error *ngIf="editForm.get('title')?.hasError('required')">
          Title is required
        </mat-error>
      </mat-form-field>
      
      <!-- Description -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea 
          matInput 
          formControlName="description" 
          placeholder="Enter description"
          rows="3">
        </textarea>
      </mat-form-field>
      
      <!-- AI-Generated Caption -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>AI Caption</mat-label>
        <textarea 
          matInput 
          formControlName="caption" 
          placeholder="AI-generated caption"
          rows="2">
        </textarea>
        <mat-hint>Automatically generated by AI analysis</mat-hint>
      </mat-form-field>
      
      <!-- Category -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Category</mat-label>
        <mat-select formControlName="category">
          <mat-option value="">No Category</mat-option>
          <mat-option *ngFor="let category of categories" [value]="category">
            {{category}}
          </mat-option>
        </mat-select>
        <mat-hint>AI-generated category</mat-hint>
      </mat-form-field>
      
      <!-- Labels (User-defined) -->
      <div class="form-section">
        <h4>Labels</h4>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Add Labels</mat-label>
          <mat-chip-grid #labelChipGrid aria-label="Label selection">
            <mat-chip-row
              *ngFor="let label of editForm.get('labels')?.value"
              (removed)="removeLabel(label)">
              {{label}}
              <button matChipRemove [attr.aria-label]="'remove ' + label">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </mat-chip-grid>
          <input 
            placeholder="Add new label..."
            [matChipInputFor]="labelChipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addLabel($event)"
            [(ngModel)]="labelInput"
            [ngModelOptions]="{standalone: true}"
            (input)="filterLabels()">
          <mat-autocomplete #autoLabels="matAutocomplete">
            <mat-option *ngFor="let label of filteredLabels" [value]="label">
              {{label}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSave()"
      [disabled]="!editForm.valid">
      Save Changes
    </button>
  </mat-dialog-actions>
</div>